import React from 'react';

export const UploadIcon = ({ color = '#27B0E0' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M15.7781 2.34526L3.67261 2.34526C3.30114 2.34526 2.99997 2.0441 2.99997 1.67262C2.99997 1.33208 3.25307 1.05065 3.5814 1.00617L3.67261 0.999981L15.7781 0.999985C16.1495 0.999985 16.4507 1.30115 16.4507 1.67262C16.4507 2.01316 16.1976 2.29459 15.8693 2.33916L15.7781 2.34526L3.67261 2.34526L15.7781 2.34526ZM9.82887 18.9349L9.7243 18.941C9.26439 18.941 8.88529 18.5948 8.83345 18.1487L8.82744 18.0441L8.82745 6.75275L5.87313 9.7059C5.54981 10.0291 5.04112 10.054 4.68928 9.78034L4.6048 9.70572C4.28157 9.38241 4.25673 8.87371 4.53036 8.52188L4.60498 8.4374L9.08709 3.95619C9.41022 3.63314 9.91865 3.60812 10.2705 3.8813L10.355 3.95583L14.8423 8.43704C15.1928 8.78708 15.1932 9.35488 14.8432 9.70537C14.5201 10.029 14.0114 10.0542 13.6594 9.78079L13.5748 9.70626L10.6212 6.75723L10.6211 18.0441C10.6211 18.5041 10.275 18.8831 9.82887 18.9349L9.7243 18.941L9.82887 18.9349Z"
      fill="#27B0E0"
    />
  </svg>
);
